import { BinanceRates } from "../models/binancerates.model";
import { responseHero } from "../utils/axiosInterceptor";

export const getBinanceRates = (assetId: number): Promise<BinanceRates[]> => {
    return new Promise<BinanceRates[]>((resolve, reject) => {
        if(!assetId) return;

        responseHero.get(`${process.env.REACT_APP_API_URL}/binancerate/${assetId}`).then((response) => {
            resolve(response.data as BinanceRates[]);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};